// import React from "react";
// import "./WhyChooseUs.css";
// import {
//   FaHourglass,
//   FaHotel,
//   FaUniversity,
//   FaHospital,
//   FaProjectDiagram,
//   FaGlobe,
// } from "react-icons/fa";

// export default function WhyChooseUs() {
//   const highlights = [
//     { title: "Years of Experience", value: "20+", icon: <FaHourglass /> },
//     { title: "Projects Delivered", value: "300+", icon: <FaProjectDiagram /> },
//     { title: "Hotels Designed", value: "150+", icon: <FaHotel /> },
//     { title: "Residential Projects", value: "100+", icon: <FaUniversity /> },
//     { title: "Hospitals / Clinics", value: "4", icon: <FaHospital /> },
//     { title: "Global Reach", value: "GCC & Beyond", icon: <FaGlobe /> },
//   ];

//   return (
//     <section className="why-choose-us-section">
//       <div className="container">
//         <h2 className="section-title" data-aos="fade-up">Why Choose Us</h2>
//         <p className="mission-text" data-aos="fade-up" data-aos-delay={100}>
//           We are a trusted design consultancy established in 2007. Our core focus includes IBMS, AV, ELV, Security, and Acoustics across Hospitality, Corporate, Government, and Healthcare. Backed by 150+ years of cumulative team experience and global clients like Marriott, Hilton, Al Futtaim, Masdar, and Meraas — our designs are engineered for precision and scale.
//         </p>

//         <div className="highlights-grid" data-aos="fade-up" data-aos-delay={200}>
//           {highlights.map((item, idx) => (
//             <div key={idx} className="highlight-card">
//               <div className="highlight-icon">{item.icon}</div>
//               <div className="highlight-value">{item.value}</div>
//               <div className="highlight-title">{item.title}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }


import React, { useEffect, useState } from "react";
import "./WhyChooseUs.css";

import {
  FaHourglass,
  FaHotel,
  FaUniversity,
  FaHospital,
  FaProjectDiagram,
  FaGlobe,
} from "react-icons/fa";

export default function WhyChooseUs() {
  const [cards, setCards] = useState([]);

  // 🔥 Icon auto-map based on title keyword
  // const iconMap = {
  //   "Years of Experience": <FaHourglass />,
  //   "Projects Delivered": <FaProjectDiagram />,
  //   "Hotels Designed": <FaHotel />,
  //   "Residential Projects": <FaUniversity />,
  //   "Hospitals / Clinics": <FaHospital />,
  //   "Global Reach": <FaGlobe />,
  // };


  // Smart keyword-based icon mapping
const getIcon = (name) => {
  const lower = name.toLowerCase();

  if (lower.includes("experience")) return <FaHourglass />;
  if (lower.includes("project")) return <FaProjectDiagram />;
  if (lower.includes("hotel")) return <FaHotel />;
  if (lower.includes("residential") || lower.includes("housing"))
    return <FaUniversity />;
  if (lower.includes("hospital") || lower.includes("clinic"))
    return <FaHospital />;
  if (lower.includes("global") || lower.includes("world") || lower.includes("international"))
    return <FaGlobe />;

  // ⭐ NEW: Handle future unknown titles
  if (lower.includes("design")) return <FaProjectDiagram />;
  if (lower.includes("security")) return <FaUniversity />;
  if (lower.includes("acoustic")) return <FaHospital />;
  if (lower.includes("smart")) return <FaGlobe />;

  // Default fallback for unknown names
  return <FaGlobe />;
};


  // Fetch API data
  const fetchCards = async () => {
    try {
      const res = await fetch("https://infosightapi.emedha.in/api/why-choose-cards");
      const data = await res.json();
      setCards(data);
    } catch (err) {
      console.log("Error fetching Why Choose cards", err);
    }
  };

  useEffect(() => {
    fetchCards();
  }, []);


  //animation 

  const topCards = cards.slice(0, 3); // Experience, Projects, Global
const bottomCards = cards.slice(3); // All project categories


const allowedNames = [
  'Years of Experience',
  'Projects Delivered',
  'Global Reach'
];


  return (
    <section className="why-choose-us-section">
      <div className="container">
        <h2 className="section-title" data-aos="fade-up">
          Why Choose Us
        </h2>

        <p className="mission-text" data-aos="fade-up" data-aos-delay={100}>
        Established in 2007, Infosight is a trusted design Consulting Firm delivering specialized expertise across Acoustics, Security, Security Risk Assessment (SRA), IT/ICT, Integrated Building Management Systems (IBMS), Audio-Visual (AV), Sustainability, and Project Management. Serving Hospitality, Corporate, Government, and Healthcare sectors, our work is backed by over 150 years of cumulative experience, with designs engineered for precision, scalability, and long-term performance.
        </p>

        {/* <div className="highlights-grid" data-aos="fade-up" data-aos-delay={200}>
          
          {cards.filter(item => allowedNames.includes(item.name)).map((item) => (
            <div key={item.id} className="highlight-card">
              <div className="highlight-icon">
                {getIcon(item.name)}
              </div>

              <div className="highlight-value">
                {item.status}
                {isFinite(item.status) ? "+" : ""}
              </div>

              <div className="highlight-title">{item.name}</div>
            </div>
          ))}

          
        </div> */}


        <div className="highlights-grid" data-aos="fade-up" data-aos-delay={200}>
  {cards
    .filter(item => allowedNames.includes(item.name))
    .map((item) => (
      <div key={item.id} className="highlight-card-wrapper">
        
        <div className="highlight-card">
          <div className="highlight-icon">
            {getIcon(item.name)}
          </div>

          <div className="highlight-value">
            {item.status}
            {isFinite(item.status) ? "+" : ""}
          </div>

          <div className="highlight-title">{item.name}</div>
        </div>

        {/* 👇 Arrow only under Projects Delivered */}
        {item.name === 'Projects Delivered' && (
          <div className="project-arrows">
            <span>↓</span>
            <span>↓</span>
            <span className="arrow-text">
              All these projects are included
            </span>
          </div>
        )}
      </div>
    ))}
</div>




<div style={{marginBottom:'20px'}}>

</div>



          {/* <div className="highlights-grid" data-aos="fade-up" data-aos-delay={200} >
          
          {cards.filter(item => !allowedNames.includes(item.name)).map((item) => (
            <div key={item.id} className="highlight-card">
              <div className="highlight-icon">
                {getIcon(item.name)}
              </div>

              <div className="highlight-value">
                {item.status}
                {isFinite(item.status) ? "+" : ""}
              </div>

              <div className="highlight-title">{item.name}</div>
            </div>
          ))}

          
        </div> */}


<div className="highlights-grid" data-aos="fade-up" data-aos-delay={200}>
  {cards
    .filter(item => !allowedNames.includes(item.name))
    .map((item) => (
      <div key={item.id} className="highlight-card">
        <div className="highlight-icon">
          {getIcon(item.name)}
        </div>

        <div className="highlight-value">
          {item.status}
          {isFinite(item.status) ? "+" : ""}
        </div>

        <div className="highlight-title">{item.name}</div>
      </div>
    ))}
</div>



      </div>
    </section>
  );
}
